import { MedicationGuideCard } from './MedicationGuideCard';

export const MedicationGuideContent = ({ guideMeds }) => {
  const list = Array.isArray(guideMeds) ? guideMeds : [];

  if (list.length === 0) {
    return (
      <div className="bg-white border border-zinc-200 rounded-xl p-6 text-center text-14 text-zinc-400">
        처방받은 약 정보가 없습니다.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 w-full">
      {list.map((m, idx) => (
        <MedicationGuideCard
          key={m.edi_code || m.item_seq || `${m.item_name}-${idx}`}
          med={m}
        />
      ))}
    </div>
  );
};

/* ─── 3. 처방전 N 탭 — Figma 434:5841 (infobox/prescription) ─── */

